import * as RequestState from './RequestState';
/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const isUninitialized = requestState => {
  return requestState === RequestState.UNINITIALIZED;
};

/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const isPending = requestState => {
  return requestState === RequestState.PENDING;
};

/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const isFulfilled = requestState => {
  return requestState === RequestState.SUCCEEDED || requestState === RequestState.FAILED;
};

/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const isSucceeded = requestState => {
  return requestState === RequestState.SUCCEEDED;
};

/** @deprecated Prefer DFC's built-in `loading`, `error`, and `data` fields. */
export const isFailed = requestState => {
  return requestState === RequestState.FAILED;
};